import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
// import ProposalAllDetailTable from './ProposalAllDetailTable'
// import ProposalAllDetails from './ProposalAllDetails'
import ProposalAllDetailForm from './ProposalAllDetailForm'
import TableReport from '../tableReport/TableReport'
import { searchProjectAllDetail, exportProjectAllDetail } from '../../../redux/actions/adminReport'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import { sessionGetItemStr, sessionSetItemStr } from '../../../utils/sessionHelpers'

export default function ProposalAllDetailWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const history = useHistory()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState()
  const [errorMsg, setErrorMsg] = useState()
  const [condition, setCondition] = useState()
  const [pagSize, setPagSize] = useState(25)
  const [clearValue, setClearValue] = useState(false)

  useEffect(() => {
    // setDataTable(mockCallData)
  }, [])

  const handleCancel = () => {
    setValueNullField()
    setDataTable(null)
  }

  const setValueNullField = () => {
    for (const key in getValues()) {
      setValue(key, null)
    }

    setClearValue(true)
    setTimeout(() => {
      setClearValue(false)
    }, 500)

    clearErrors()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    let request = {
      projectCode: data.projectCode,
      projectName: data.projectName,
      contactNo: data.contactNo,
      firstNameProjectCoordinator: data.firstNameProjectCoordinator,
      lastNameProjectCoordinator: data.lastNameProjectCoordinator,
      firstNameResponsinator: data.firstNameResponsinator,
      lastNameResponsinator: data.lastNameResponsinator,
      responsinatorIdCard: data.responsinatorIdCard,
      responsinatorTelephone: data.responsinatorTelephone,
      responsinatorEmail: data.responsinatorEmail,
      firstNameGrentree: data.firstNameGrentree,
      lastNameGrentree: data.lastNameGrentree,
      grentreeIdCard: data.grentreeIdCard,
      grentreeTelephone: data.grentreeTelephone,
      grentreeEmail: data.grentreeEmail,
      organization: data.organization,
      taxNo: data.taxNo,
      projectStatus: data?.projectStatus || [],
      projectStartDate: data.projectStartDate,
      projectEndDate: data.projectEndDate,
      projectDepartment: data.projectDepartment,
      roundNo: data.projectRoundNoOption,
      pageNumber: 1,
      pageSize: pagSize,
    }

    setCondition(data)
    handlePreviewReport(request)
  }

  const handlePreviewReport = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await searchProjectAllDetail(request)
      console.log('response', response)

      if (response.model) {
        setDataTable(response.model)
      } else {
        handelSetErrorMsg('error', 'ไม่สามารถแสดงข้อมูลได้')
      }
    } catch (e) {
      setIsError(true)
      handelSetErrorMsg('error', e.response.data.errors?.message || 'ไม่สามารถแสดงข้อมูลได้')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    let desc = description ? description : `ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ`
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  const handelGetSchemaOnReload = async (pagesize, pagenumber) => {
    // console.log('handelGetSchemaOnReload ', condition, pagesize, pagenumber)

    let request = {
      projectCode: condition.projectCode,
      projectName: condition.projectName,
      contactNo: condition.contactNo,
      firstNameProjectCoordinator: condition.firstNameProjectCoordinator,
      lastNameProjectCoordinator: condition.lastNameProjectCoordinator,
      firstNameResponsinator: condition.firstNameResponsinator,
      lastNameResponsinator: condition.lastNameResponsinator,
      responsinatorIdCard: condition.responsinatorIdCard,
      responsinatorTelephone: condition.responsinatorTelephone,
      responsinatorEmail: condition.responsinatorEmail,
      firstNameGrentree: condition.firstNameGrentree,
      lastNameGrentree: condition.lastNameGrentree,
      grentreeIdCard: condition.grentreeIdCard,
      grentreeTelephone: condition.grentreeTelephone,
      grentreeEmail: condition.grentreeEmail,
      organization: condition.organization,
      taxNo: condition.taxNo,
      projectStatus: condition?.projectStatus || [],
      projectStartDate: condition.projectStartDate,
      projectEndDate: condition.projectEndDate,
      projectDepartment: condition.projectDepartment,
      roundNo: condition.projectRoundNoOption,
      pageNumber: pagenumber,
      pageSize: pagesize,
    }

    setPagSize(pagesize)
    handlePreviewReport(request)
  }

  const handleOnClickExport = (data) => {
    console.log('handleOnClickExport ', data)

    let request = {
      projectCode: data.projectCode,
      projectName: data.projectName,
      contactNo: data.contactNo,
      firstNameProjectCoordinator: data.firstNameProjectCoordinator,
      lastNameProjectCoordinator: data.lastNameProjectCoordinator,
      firstNameResponsinator: data.firstNameResponsinator,
      lastNameResponsinator: data.lastNameResponsinator,
      responsinatorIdCard: data.responsinatorIdCard,
      responsinatorTelephone: data.responsinatorTelephone,
      responsinatorEmail: data.responsinatorEmail,
      firstNameGrentree: data.firstNameGrentree,
      lastNameGrentree: data.lastNameGrentree,
      grentreeIdCard: data.grentreeIdCard,
      grentreeTelephone: data.grentreeTelephone,
      grentreeEmail: data.grentreeEmail,
      organization: data.organization,
      taxNo: data.taxNo,
      projectStatus: data?.projectStatus || [],
      projectStartDate: data.projectStartDate,
      projectEndDate: data.projectEndDate,
      projectDepartment: data.projectDepartment,
      roundNo: data.projectRoundNoOption,
    }
    console.log('request ', request)
    handleExportFile(request)
  }

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await exportProjectAllDetail(request)

      if (file) {
        downloadFile(file, file.name || `ข้อมูลโครงการ`)
      } else {
        handelSetErrorMsg('error')
      }
    } catch (e) {
      let errorJson = JSON.parse(await e.response.data.text())
      setIsError(true)
      handelSetErrorMsg('error', errorJson?.errors?.message)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleClickLinked = (versionid) => {
    sessionStorage.setItem('projectId', versionid)
    sessionStorage.setItem('param', '')

    const xurl = `${process.env.REACT_APP_SERVER_URL}${pathname.proposal.overview.overviewCoworker}`

    window.open(xurl, '_blank')
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.searchObject.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        <ProposalAllDetailForm
          schema={formSchema.searchObject}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          // handelPreview={onSubmit}
          clearValue={clearValue}
        />

        <hr />

        {errorMsg && (
          <Message
            showIcon
            type={errorMsg.type}
            description={errorMsg.description}
            style={{ marginBottom: 20 }}
          />
        )}

        <ButtonPanelWidget
          isEdit={true}
          isError={isError}
          buttonText={formSchema.searchObject.buttonText}
          onCancel={handleSubmit(handleCancel)}
          onSave={handleSubmit(onSubmit)}
        />
      </Panel>

      {isLoading && !isError && <OverlayLoader />}

      {dataTable && (
        <>
          <div style={{ marginTop: 30 }}>
            <TableReport
              schema={dataTable}
              headerHeightSize={40}
              Controller={Controller}
              control={control}
              pagination={true}
              loading={isLoading}
              onReload={handelGetSchemaOnReload}
              onClickExport={handleSubmit(handleOnClickExport)}
              onClickLinked={handleClickLinked}
            />
          </div>
          <br />
        </>
      )}
    </>
  )
}
